export default [
  {
    name: 'auth-login',
    path: '/login',
    component: () => import('@/app-modulo/documento/login/Login.vue'),
    meta: {
      resource: 'logininterno',
      action: 'auditar',
      requiredAuth: false,
      layout: 'full',
    },
  },
]
